import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

// Matrice « catégorie de notification × groupe » (Configuration → Notifications,
// boss). L'éligibilité est de la donnée : le registre backend ne garde que le
// structurel (cycle, vocal, lecture ouverte).
export const FETCH_NOTIF_ELIGIBILITE_BEGIN = "FETCH_NOTIF_ELIGIBILITE_BEGIN"
export const FETCH_NOTIF_ELIGIBILITE_SUCCESS = "FETCH_NOTIF_ELIGIBILITE_SUCCESS"
export const FETCH_NOTIF_ELIGIBILITE_ERROR = "FETCH_NOTIF_ELIGIBILITE_ERROR"
export const PUT_NOTIF_ELIGIBILITE_BEGIN = "PUT_NOTIF_ELIGIBILITE_BEGIN"
export const PUT_NOTIF_ELIGIBILITE_SUCCESS = "PUT_NOTIF_ELIGIBILITE_SUCCESS"
export const PUT_NOTIF_ELIGIBILITE_ERROR = "PUT_NOTIF_ELIGIBILITE_ERROR"
export const PUT_NOTIF_ELIGIBILITE_RESET = "PUT_NOTIF_ELIGIBILITE_RESET"

const URL_ELIGIBILITE = "api/notifications/eligibilite"

export const fetchNotifEligibiliteBegin = () => ({
	type: FETCH_NOTIF_ELIGIBILITE_BEGIN,
})
export const fetchNotifEligibiliteSuccess = (payload) => ({
	type: FETCH_NOTIF_ELIGIBILITE_SUCCESS,
	payload,
})
export const fetchNotifEligibiliteError = (error) => ({
	type: FETCH_NOTIF_ELIGIBILITE_ERROR,
	payload: error,
})
export const putNotifEligibiliteBegin = () => ({
	type: PUT_NOTIF_ELIGIBILITE_BEGIN,
})
export const putNotifEligibiliteSuccess = (payload) => ({
	type: PUT_NOTIF_ELIGIBILITE_SUCCESS,
	payload,
})
export const putNotifEligibiliteError = (error) => ({
	type: PUT_NOTIF_ELIGIBILITE_ERROR,
	payload: error,
})
export const putNotifEligibiliteReset = () => ({
	type: PUT_NOTIF_ELIGIBILITE_RESET,
})

export function fetchNotifEligibilite() {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		if (!token) return Promise.resolve()
		dispatch(fetchNotifEligibiliteBegin())
		return fetch(`${URL}${URL_ELIGIBILITE}`, {
			headers: { Authorization: `Bearer ${token}` },
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(fetchNotifEligibiliteSuccess(json))
				return json
			})
			.catch(catchApiError(dispatch, fetchNotifEligibiliteError))
	}
}

// `eligibilite` : { [cle de categorie]: [noms de groupes] } — remplace la
// matrice côté serveur (transaction atomique) et renvoie l'état à jour.
// `silent` : l'erreur s'affiche dans le modal de confirmation, pas en toast.
export function putNotifEligibilite(eligibilite) {
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(putNotifEligibiliteBegin())
		return fetch(`${URL}${URL_ELIGIBILITE}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`,
			},
			body: JSON.stringify({ eligibilite }),
		})
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => {
				dispatch(putNotifEligibiliteSuccess(json))
				return json
			})
			.catch(
				catchApiError(dispatch, putNotifEligibiliteError, {
					silent: true,
				}),
			)
	}
}
